import { createOrReuseThread, lookupThread } from '../../api/messenger'

export async function apiCheckExistingDm(targetUserId: string | number): Promise<{ threadId: string | null }> {
  const target = Number(targetUserId)
  if (!Number.isFinite(target) || target <= 0) return { threadId: null }
  const found = await lookupThread([target])
  return { threadId: found.threadId != null ? String(found.threadId) : null }
}

export async function apiOpenDm(targetUserId: string | number): Promise<{ threadId: string }> {
  const target = Number(targetUserId)
  if (!Number.isFinite(target) || target <= 0) throw new Error('Invalid target user id')
  const found = await lookupThread([target])
  if (found.threadId != null) return { threadId: String(found.threadId) }
  const created = await createOrReuseThread({ members: [target] })
  return { threadId: String(created.threadId) }
}
